export default __webpack_public_path__ + "static/media/q12022.88f1b432.png";